/**
 * Generate a link and download file from bytes
 *
 * @param {array} bytes - File in bytes
 * @param {string} name - Name of file
 */
const downloadFileFromBytes = (bytes, name) => {
  const href = window.URL.createObjectURL(new Blob([bytes]));
  const link = document.createElement('a');

  link.href = href;

  link.setAttribute('download', name);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
};

export default downloadFileFromBytes;
